import { AmplitudeTracker } from './trackers/amplitude-tracker';
import { Tracker } from './tracker';
import { isDebug } from '../config';

const amplitude = new AmplitudeTracker({
  serverZone: 'EU',
  defaultTracking: true,
  autocapture: {
    pageViews: false,
  },
});

export const tracker = new Tracker(amplitude, { debug: isDebug });
